import { CLIENT_ID } from './client.model'
import { CLUB_ID } from './club.model'
import { EVENT_ID } from './event.model'

export type AREA_ID = string | number
export class Area {
  id: AREA_ID
  client_id: CLIENT_ID
  club_id: CLUB_ID
  event_id: number
  parent_id: number | number[] | string
  name: string
  active?: boolean
  type?: string
  /** Per-area config bag, namespaced by feature — `{ booking: {…} }` for YB-2066. */
  extra?: Record<string, any> | null
}

export class CreateAreaInput {
  client_id: CLIENT_ID = NaN
  event_id: EVENT_ID = NaN
  club_id: CLUB_ID = NaN
  parent_id: number = NaN
  name: string = ''
}

export class UpdateAreaInput {
  id: AREA_ID = NaN
  client_id: CLIENT_ID = NaN
  event_id: EVENT_ID = NaN
  club_id: CLUB_ID = NaN
  parent_id: number = NaN
  name: string = ''
  active?: boolean = false
  type?: string = ''
  /**
   * This class doubles as the area SELECTION SET for every `areas { … }` block (the queries join
   * `Object.keys(new UpdateAreaInput())`), so `extra` has to live here for the area drawer to read
   * back the booking config it saved — without it the drawer reopens blank (YB-2066).
   */
  extra?: Record<string, any> | null = null
}
